<div *ngIf="huddleEnable; else noHuddleSetup">
  <!-- <div id="global-filter-section">
    <div class="container-fluid padding-0">
      <div class="row">
        <div class="col-4">
          <div class="row"></div>
        </div>
        <div class="col"></div>
        <div class="col-4">
          <div class="row">
            <div class="col-6"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="global-filter-breadcrum"></div>
      </div>
    </div>
  </div> -->
  <!-- <div class="border-below">
    <span
      (click)="tabChangeHandler(tabType.SUMMARY)"
      [class.active]="getCurrentTab() === tabType.SUMMARY"
      >Summary</span
    >

    <span
      class="mx-1"
      (click)="tabChangeHandler(tabType.ALL_HUDDLES)"
      [class.active]="getCurrentTab() === tabType.ALL_HUDDLES"
      >All huddles</span
    >

    <span
      class="mx-1"
      (click)="tabChangeHandler(tabType.ALL_ACTION_PLANS)"
      [class.active]="getCurrentTab() === tabType.ALL_ACTION_PLANS"
      >All action plans</span
    >

    <span
      class="mx-1"
      (click)="tabChangeHandler(tabType.ALL_SUGGESTIONS)"
      [class.active]="getCurrentTab() === tabType.ALL_SUGGESTIONS"
      >All suggestions</span
    >

    <span
      class="mx-1"
      (click)="tabChangeHandler(tabType.ALL_SPOTLIGHTS)"
      [class.active]="getCurrentTab() === tabType.ALL_SPOTLIGHTS"
      >All spotlights</span
    >
  </div> -->

  <div class="ltms-tabs">
    <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === tabType.SUMMARY }"
      (click)="tabChangeHandler(tabType.SUMMARY)">Summary</span>
    <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === tabType.ALL_HUDDLES }"
      (click)="tabChangeHandler(tabType.ALL_HUDDLES)">All huddles</span>
    <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === tabType.ALL_ACTION_PLANS }"
      (click)="tabChangeHandler(tabType.ALL_ACTION_PLANS)">All action plans</span>
    <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === tabType.ALL_SUGGESTIONS }"
      (click)="tabChangeHandler(tabType.ALL_SUGGESTIONS)">All suggestions</span>
    <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === tabType.ALL_SPOTLIGHTS }"
      (click)="tabChangeHandler(tabType.ALL_SPOTLIGHTS)">All spotlights</span>
  </div>
  <div *ngIf="activeTab === tabType.SUMMARY">
    <app-huddle-summary></app-huddle-summary>
  </div>
  <div *ngIf="activeTab === tabType.ALL_HUDDLES">
    <app-all-huddles></app-all-huddles>
  </div>
  <div *ngIf="activeTab === tabType.ALL_ACTION_PLANS">
    <app-all-action-plans></app-all-action-plans>
  </div>
  <div *ngIf="activeTab === tabType.ALL_SUGGESTIONS">
    <app-all-suggestions></app-all-suggestions>
  </div>
  <div *ngIf="activeTab === tabType.ALL_SPOTLIGHTS">
    <app-all-spotlights></app-all-spotlights>
  </div>
</div>
<ng-template #noHuddleSetup>
  <div class="no-huddle-message">
    <div class="message-content">
      <h3>No Huddle Configuration Available</h3>
      <p>
        It looks like this brand doesn't have a huddle setup. Please contact
        your administrator for further assistance or to enable this feature.
      </p>
    </div>
  </div>
</ng-template>